import { toArray } from './toArray';

export function getTooltipTargets(id) {
  const escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  return toArray(document.querySelectorAll(`[data-tooltip-id="${escaped}"]`));
}
